import BordableModel from '../BordableModel';
import PropertyDescriptor from '../../utils/PropertyDescriptor';

export default class SelectorModel extends BordableModel {

    pointerEvents = new PropertyDescriptor("none", '鼠标事件是否穿透', "其他", "enum");

    constructor(opts = {}) {
        super();
        this.defineAllProperties();

        this.borderWidth = 3;
        this.borderColor = "rgb(255 208 76)";
        this.backgroundColor = "";

        for (var p in opts) {
            this[p] = opts[p];
        }
    }

    toStyle() {
        return {
            ...super.toStyle(),
            pointerEvents: this.pointerEvents,
        }
    }
}
